











































































































import Vue from 'vue';
import EntitiesTable from '@/common/components/entities/EntitiesTable.vue';
import { EntityFilterType } from '@/common/components/entities/entities.types';
import DeleteModal from '@/common/components/modals/DeleteModal.vue';
import api from '@/common/api';
import LoadingModal from '@/common/components/LoadingModal.vue';
import PaidFeatureNotEnabled from '@/common/components/PaidFeatureNotEnabled.vue';
import { mapGetters } from 'vuex';
import { InvoiceStatus } from './invoices.types';

export default Vue.extend({
  data() {
    return {
      deleteModal: false,
      closeModal: false,
      reLoadData: false,
      loadingText: '',
      isSubmitting: false,
      invoiceToDelete: {} as any,
      closeInvoice: false,
      modalAction: '',
      invoiceToClose: {} as any,
      config: {
        pageTitle: 'Manage Invoices',
        header: 'Invoices',
        routerBase: 'merchant.invoices',
        apiPath: 'merchant/invoice',
        entityName: 'invoice',
        identifierProperty: 'invoiceNumber',
        reLoadData: false,
        reportFileName: 'invoice_report',
        createButtonText: 'Create New',
        filters: [
          {
            name: 'startDueDate',
            display: 'Due Date Start Date',
            type: EntityFilterType.DATE,
            value: '',
            open: false,
          },
          {
            name: 'endDueDate',
            display: 'Due Date End Date',
            type: EntityFilterType.DATE,
            value: '',
            open: false,
          },
          {
            name: 'status',
            display: 'Status',
            value: '',
            type: EntityFilterType.SELECT_CHECK,
            items: [
              { display: 'Draft', value: 1 },
              { display: 'Sent', value: 2 },
              { display: 'Partially Paid', value: 3 },
              { display: 'Paid', value: 4 },
              { display: 'Closed', value: 5 },
              { display: 'Past Due', value: 6 },
            ] as any[],
            localStorageKey: 'coregateway.invoices.filterByStatus',
          },
        ],
        headers: [
          {
            text: 'ID',
            value: 'id',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '6rem',
            align: ' d-none',
          },
          {
            text: 'Invoice #',
            value: 'invoiceNumber',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '8rem',
          },
          {
            text: 'invoiceCustomer',
            value: 'invoiceCustomer',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            align: ' d-none',
          },
          {
            text: 'lineItems',
            value: 'lineItems',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            align: ' d-none',
          },
          {
            text: 'Status',
            value: 'status',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '8rem',
          },
          {
            text: 'Billed To',
            value: 'billedTo',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '10rem',
          },
          {
            text: 'Issue Date',
            value: 'invoiceInformation',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '10rem',
          },
          {
            text: 'Due Date',
            value: 'invoiceInformation.dueDateFormatted',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '8rem',
          },
          {
            text: 'Amount Paid',
            value: 'amountPaid',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '9rem',
          },
          {
            text: 'Amount Due',
            value: 'amountDue',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '8rem',
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
            align: 'center',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '20rem',
          },
        ],
      },
    };
  },
  methods: {
    promptForDelete(invoice: any) {
      this.deleteModal = true;
      this.invoiceToDelete = invoice;
      this.closeInvoice = false;
      this.modalAction = 'delete';
    },
    promptForClose(invoice: any) {
      this.deleteModal = true;
      this.invoiceToDelete = invoice;
      this.invoiceToClose = invoice;
      this.closeInvoice = true;
      this.modalAction = 'close';
    },
    resend(invoice: any) {
      this.loadingText = 'Resending invoice...';
      this.isSubmitting = true;
      api
        .post(`/merchant/invoice/${invoice.id}/send`)
        .then(this.showSuccess)
        .catch(this.handleSaveError);
    },
    downloadPDF(invoice: any) {
      if (invoice.invoiceInformation.pdfUrl) {
        window.location.href = invoice.invoiceInformation.pdfUrl;
      }
    },
    moreActionHandler(invoice: any, status: any) {
      if (status === InvoiceStatus.CLOSED) {
        this.promptForClose(invoice);
      } else if (status === InvoiceStatus.DELETE) {
        this.promptForDelete(invoice);
      } else {
        this.updateStatus(invoice, status);
      }
    },
    updateStatus(invoice: any, status: any) {
      this.reLoadData = false;
      this.loadingText = 'Updating status...';
      this.isSubmitting = true;
      api
        .patch(`${this.config.apiPath}/${invoice.id}/status/`, { status })
        .then(() => {
          this.isSubmitting = false;
          this.reLoadData = true;
          this.deleteModal = false;
        })
        .catch(({ response }) => {
          const message = response?.data?.message || 'Failed to update the status of the invoice. Try again.';
          this.$toasted.error(`${message} (${response.status})`);
        });
    },
    deleteEntity() {
      if (this.closeInvoice === true) {
        this.closeInvoice = false;
        this.updateStatus(this.invoiceToDelete, InvoiceStatus.CLOSED);
      } else {
        this.loadingText = 'Deleting invoice...';
        this.isSubmitting = true;
        this.deleteModal = false;
        this.reLoadData = false;
        api
          .delete(`${this.config.apiPath}/${this.invoiceToDelete.id}`)
          .then(() => {
            this.invoiceToDelete = null;
            this.reLoadData = true;
            this.isSubmitting = false;
          })
          .catch(({ response }) => {
            const message = response?.data?.message || 'Failed to delete invoice. Try again.';
            this.$toasted.error(`${message} (${response.status})`);
          });
      }
    },
    closeEntity() {
      this.loadingText = 'Closing invoice...';
      this.isSubmitting = true;
      this.closeModal = false;
      this.reLoadData = false;
      api
        .put(`${this.config.apiPath}/close/${this.invoiceToClose.id}`)
        .then(() => {
          this.invoiceToClose = null;
          this.reLoadData = true;
          this.isSubmitting = false;
        })
        .catch(({ response }) => {
          const message = response?.data?.message || 'Failed to close invoice. Try again.';
          this.$toasted.error(`${message} (${response.status})`);
        });
    },
    invoiceActionsByStatus(itemStatus: string): any[] {
      return this.invoiceActionItems.filter((it) => this.isClosable(itemStatus, it.value));
    },
    isClosable(itemStatus: string, statusAction: string): boolean {
      let isClosable = true;
      if (statusAction === InvoiceStatus.DELETE) {
        isClosable = false;
      }
      if (itemStatus === InvoiceStatus.CLOSED) {
        isClosable = (statusAction === InvoiceStatus.DELETE || statusAction !== InvoiceStatus.CLOSED);
      }
      return isClosable;
    },
    closeDeleteModal() {
      this.deleteModal = false;
    },
    closeCloseModal() {
      this.closeModal = false;
    },
    showSuccess() {
      this.isSubmitting = false;
      this.$toasted.success('Invoice resent successfully!');
    },
    handleSaveError({ response }: { response: any }) {
      if (response.status === 422) {
        let msg: any = '';
        if (response?.data?.errors) {
          const errors = response?.data?.errors;
          Object.keys(errors).forEach((key: any, idx: any) => {
            if (idx > 0) msg += '<br />';
            msg += `${errors[key]}`;
          });
        } else if (response?.data?.message) {
          msg += response?.data?.message;
        }

        if (msg) this.$toasted.error(msg);
        else this.$toasted.error(`There was a problem resending the invoice. (${response.status})`);
      } else {
        this.$toasted.error(`There was a problem resending the invoice. (${response.status})`);
      }
    },
    onFilterApplied() {
      const filter = this.config.filters.find((f) => f.name === 'status');
      if (localStorage && filter?.localStorageKey) {
        localStorage.setItem(filter.localStorageKey, JSON.stringify(filter?.value));
      }
    },
  },
  computed: {
    ...mapGetters(['isInvoicingEnabled']),
    currentDate() {
      const yourDate = new Date();
      return yourDate.toISOString().split('T')[0]; // returns date in yyyy-mm-dd format
    },
    invoiceActionItems(): any[] {
      return [
        {
          title: 'Mark as Paid', icon: 'mdi-cash', value: InvoiceStatus.PAID,
        },
        {
          title: 'Mark as Sent', icon: 'mdi-email', value: InvoiceStatus.SENT,
        },
        {
          title: 'Mark as Closed', icon: '$delete', value: InvoiceStatus.CLOSED,
        },
        {
          title: 'Delete Invoice', icon: 'mdi-trash-can', value: InvoiceStatus.DELETE,
        },
      ];
    },
  },
  components: {
    EntitiesTable,
    DeleteModal,
    LoadingModal,
    PaidFeatureNotEnabled,
  },
});
